<template>
  <PropertyOnboardingStep
    title="Lease term & availability"
    :is-next-button-disabled="formRef?.form.validation.$invalid"
    :submit="submit"
  >
    <LeaseTermsForm ref="formRef" />
  </PropertyOnboardingStep>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { LeaseTermsForm } from '@tallo/investor/property';

import PropertyOnboardingStep from '../property-onboarding-step.vue';

const formRef = ref<InstanceType<typeof LeaseTermsForm>>();

async function submit() {
  await formRef.value?.save();
}
</script>
